import { render, staticRenderFns } from "./PatchLocations.vue?vue&type=template&id=fa16c1bc"
import script from "./PatchLocations.vue?vue&type=script&lang=js"
export * from "./PatchLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports